<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <GeneralCustomizations />
    <div class="portal-preview elevation-1">
      <BrowserHead
        :get-value="getValue"
        tab-name="Customer Portal"
        url="https://schedule.online"
      />
      <div>
        <div
          class="portal-header"
          :style="`color: #FFF; background-color: ${getValue(
            'secondary_color'
          )}`"
        >
          <img
            :src="getValue('light_logo_url')"
            alt="logo"
            height="25"
            class="h-[25px]"
          />
          <div
            class="portal-button"
            :style="`color: #FFF; background-color: ${getValue(
              'primary_color'
            )}`"
          >
            Schedule Appointment
          </div>
        </div>
        <div
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <h5 class="mt-4 mb-0">Appointment #1234</h5>
          <hr style="width: 300px" />
          <div
            style="width: 300px; height: 50px; background: #fff"
            class="elevation-1 mb-1 px-4 py-1"
          >
            <div class="skeleton-bar"></div>
            <div class="skeleton-bar"></div>
          </div>
          <div class="portal-map elevation-1">
            <img :src="getValue('pinicon_url')" alt="pinicon" height="45" />
          </div>
          <div
            class="portal-button"
            :style="`color: #FFF; background-color: ${getValue(
              'primary_color'
            )}`"
          >
            Button
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import BrowserHead from "../BrowserHead.vue";
import GeneralCustomizations from "../GeneralCustomizations.vue";
import { injectUseTenantCustomization } from "../useTenantCustomization";

const { getValue } = injectUseTenantCustomization();
</script>

<style lang="scss" scoped>
.two-columns {
  display: grid;
  grid-template-columns: calc(50% - 18px) calc(50% - 18px);
  gap: 36px;
}
.portal-preview {
  background: #fafafa;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  .portal-header {
    height: 48px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .portal-map {
    width: 300px;
    height: 300px;
    background: gray;
    margin: 25px 0;
    background-image: image-url("map_mock.png");
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .portal-button {
    border-radius: 28px;
    padding: 0px 16px;
    text-align: center;
    display: inline-flex;
    min-width: 120px;
    height: 36px;
    align-items: center;
    justify-content: center;
  }
}
</style>
